import {
  Dialog,
  DialogActions,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogTitle,
  Button,
} from '@eye-able/ui';
import { useAtom } from 'jotai';
import { demoModeAtom, showFaceliftWelcomeBannerAtom } from '@/global-store';
import { assetUrl } from '@helpers/assetUrl';
import { useInlineTranslation } from '@/i18n/hooks/useInlineTranslation';

export const FaceliftWelcomeBanner = () => {
  const [show, setShow] = useAtom(showFaceliftWelcomeBannerAtom);
  const [demoMode] = useAtom(demoModeAtom);
  const { t, ts, i18n } = useInlineTranslation();

  const suffix = i18n.resolvedLanguage === 'de' ? '.de' : '';

  if (!show || demoMode) {
    return null;
  }

  return (
    <Dialog defaultOpen={true}>
      <DialogContent persistent={true}>
        <DialogTitle>{t('faceliftWelcomeBannerTitle')}</DialogTitle>
        <DialogDescription>
          <div className='eye:flex eye:flex-col eye:gap-y-16'>
            <img
              className='eye:mb-8'
              alt={ts('faceliftWelcomeBannerAltText')}
              src={assetUrl(`faceliftWelcomeApplication${suffix}.png`)}
            />
            <h1 className='eye:font-bold eye:flex eye:items-center eye:justify-center eye:gap-12'>
              <span role='img' aria-hidden className='eye:text-42'>
                🥳
              </span>
              {t('faceliftWelcomeBannerText1')}
            </h1>
            <p>
              <strong>{t('faceliftWelcomeBannerText2')}</strong>
              <br />
              {t('faceliftWelcomeBannerText3')}
            </p>
            <div>
              <strong>{t('faceliftWelcomeBannerText4')}</strong>
              <ul className='eye:list-disc eye:pl-16'>
                <li className='eye:list-outside'>
                  {t('faceliftWelcomeBannerText5')}
                </li>
                <li className='eye:list-outside'>
                  {t('faceliftWelcomeBannerText6')}
                </li>
              </ul>
            </div>
          </div>
        </DialogDescription>
        <DialogActions>
          <DialogClose asChild>
            <Button onClick={() => setShow(false)} variant='yellow'>
              {t('faceliftWelcomeBannerButton')}
            </Button>
          </DialogClose>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};
